export const API_tags_used = (workspaceId: string): string => `/api/v1/tags/used/${workspaceId}`;
export const API_tags_excel = (workspaceId: string): string => `/api/v1/tags/excel/${workspaceId}`;
